/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 21/6/2023
 */

import {
  Box,
  Button,
  Container,
  Paper,
  Toolbar,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import OfferDialog from "../Components/Offer/OfferDialog";
import OfferTable from "../Components/Offer/OfferTable";
import { openAddOfferModal } from "../Store/Slices/offerSlice";
import styles from "./Management.module.css";
import SearchBar from "../Components/Shared/SearchBar";
import { useGetAllOffersQuery } from "../Store/Services/OfferService";

const OfferManagement = () => {
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState([]);

  const {
    data: offer,
    isLoading,
  } = useGetAllOffersQuery();


  const roles = sessionStorage.getItem("roles");

  return (
    roles?.split(",").includes("PRIV_ES_DISPLAY_OFFERS") ? (
    <Paper elevation={3} className={styles.pageContainer} style={{backgroundImage: `url(${process.env.REACT_APP_IMAGE_URL}E_SERVICE/thumbnail_Management.png)`}}>
      <Box>
        <Toolbar className={styles.subNavBar}>
          <Typography className={styles.topic}>Offer Management</Typography>
          {roles?.split(",").includes("PRIV_ES_ADD_OFFER") ? (<Button
            variant="contained"
            color="primary"
            className={styles.buttonItem}
            onClick={() => dispatch(openAddOfferModal())}
          >
            Add Offer
          </Button> ) : null }
        </Toolbar>
      </Box>

      <Container className={styles.container}>
        {!isLoading && (
          <SearchBar
            data={offer || []}
            setSearchData={setSearchData}
            text="Search Offers"
            search="offer"
          />
        )}
      </Container>

      <Container>
        <OfferTable data={searchData} />
      </Container>

      <OfferDialog />
    </Paper> ) : null
  );
};

export default OfferManagement;
